Vue.component('gallery', {
  template: '#vue-gallery',
  props: {
    images: {
      type: Array,
      default: function () {
        return [];
      },
    },
    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
    carousel: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    id: {
      type: String,
      default: 'blueimp-gallery',
    },
  },
  data: function () {
    return {
      instance: null,
    };
  },
  watch: {
    index: function (value) {
      if (this.carousel) {
        return;
      }
      if (value !== null) {
        this.open(value);
      } else {
        if (this.instance) {
          this.instance.close();
        }
        this.$emit('close');
      }
    },
  },
  mounted: function () {
    loadScript('/js/blueimp-gallery.min.js');

    if (this.carousel) {
      this.open();
    }
  },
  destroyed: function () {
    if (this.instance !== null) {
      this.instance.close();
      this.instance = null;
    }
  },
  methods: {
    open: function (index) {
      const self = this;
      
      if (typeof index === 'undefined') {
        index = 0;
      }

      loadScript('/js/blueimp-gallery.min.js', function () {
        instance = typeof blueimp.Gallery !== 'undefined' ? blueimp.Gallery : blueimp;

        options = Object.assign({
          toggleControlsOnReturn: false,
          toggleControlsOnSlideClick: false,
          closeOnSlideClick: false,
          // srcsetProperty: 'srcset', // to nie dziala na ten moment
          carousel: self.carousel,
          container: '#' + self.id,
          index: self.index, //null,
          onopen: function () { self.$emit('onopen') },
          onopened: function () { self.$emit('onopened') },
          onslide: self.onSlideCustom,
          onslideend: function (index, slide) { self.$emit('onslideend', [index, slide]) },
          onslidecomplete: function (index, slide) { self.$emit('onslidecomplete', [index, slide]) },
          onclose: function () { self.$emit('close') },
          onclosed: function () { self.$emit('onclosed') },
        }, self.options);

        if (self.carousel) {
          options.container = self.$el;
        }

        self.instance = instance(self.images, options);
      });
    },
    onSlideCustom: function (index, slide) {
      this.$emit('onslide', [index, slide]);

      // image = ($(window).width() > 768) ? this.images[index]; $(window).width() // niedokonczone rozne wielkosci zdjec
      image = this.images[index];
      if (image !== undefined) {
        text = image.description;
        node = this.instance.container.find('.description');
        if (text) {
          node.empty();
          node[0].appendChild(document.createTextNode(text));
        }
      }
    }
  }
});
